module.exports = __webpack_public_path__ + "static/media/s10.43dd71ce.png";